module.exports = "//public.zight.com/packs/media/images/annotate/emoji-13b972be18042e00c2b121efbed9e8d7.png";